<template>
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.50012 18.4999V3.49988C2.50012 2.94759 2.94784 2.49988 3.50012 2.49988H18.5001C19.0524 2.49988 19.5001 2.94759 19.5001 3.49988V18.4999C19.5001 19.0522 19.0524 19.4999 18.5001 19.4999H3.50012C2.94784 19.4999 2.50012 19.0522 2.50012 18.4999Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M6.5 3V7C6.5 7.55228 6.94772 8 7.5 8H14.5C15.0523 8 15.5 7.55228 15.5 7V3" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12.5 5.5V3H13.5V5.5H12.5Z" stroke="currentColor" stroke-linecap="round"/>
        <path d="M5.5 19.5V11.5C5.5 10.9477 5.94772 10.5 6.5 10.5H15.5C16.0523 10.5 16.5 10.9477 16.5 11.5V19.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

</template>

<script>
export default {
    name: 'SVGSave',
};
</script>

<style scoped lang="scss">

</style>
